import { useDisplayNames } from '@spotify/confidence-core-react';

import { ValueCapInput } from '../ValueCapInput';
import { useAggregatedMeasurement } from './context';

export type CapProps = {
  idPrefix: string;
  valueLabel?: string;
  short?: boolean;
};

export const Cap = ({ idPrefix, valueLabel = 'values', short }: CapProps) => {
  const { cap, entity, onCapChange } = useAggregatedMeasurement();
  const { displayNames } = useDisplayNames();

  return (
    <ValueCapInput
      value={cap}
      idPrefix={idPrefix}
      valueLabel={valueLabel}
      onChange={onCapChange}
      entityName={displayNames.get(entity)}
      short={short}
    />
  );
};
